import { ApiService } from "pwapi";

import {
  LABS_LIST_FAILURE,
  LABS_LIST_REQUEST,
  LABS_LIST_SUCCESS,
} from "./constants";
import { AsyncSagaAction, createAsyncSaga } from "../utils/asyncActions";

export const getLabs = createAsyncSaga(
  LABS_LIST_REQUEST,
  LABS_LIST_SUCCESS,
  LABS_LIST_FAILURE,
  () => `/labs`,
  ApiService.listLabs
) as AsyncSagaAction<{ limit: number; offset: number }>;
